import { ApolloLink, Observable } from "@apollo/client";
import stitchSubLinksResults from "./stitchPartialResults";
import { reportRuntimeError } from "../telemetry/internalReporting";
function createExecutionPromise(execution, operationContext) {
    const { query, link, variables, containsNonNullableFields } = execution;
    let subscription = null;
    const promise = new Promise(function apolloLinkExecution(resolve) {
        try {
            subscription = ApolloLink.execute(link, {
                query,
                variables,
                context: operationContext
            }).subscribe({
                next: function splitLinkNext(result) {
                    const enhancedResult = {
                        success: true,
                        linkResult: result,
                        extensions: {
                            containsNonNullableFields
                        }
                    };
                    resolve(enhancedResult);
                },
                error: function splitLinkError(error) {
                    resolve({
                        success: false,
                        error
                    });
                }
            });
        } catch (error) {
            reportRuntimeError(operationContext.observabilityFns, error);
            resolve({
                success: false,
                error
            });
        }
    });
    const unsubscribe = ()=>{
        if (subscription) {
            subscription.unsubscribe();
            subscription = null;
        }
    };
    return {
        promise,
        unsubscribe
    };
}
/**
 * Creates an Observable that executes multiple split queries and emits the combined result.
 * This function handles the common pattern used in multiple Apollo links.
 */ export default function createSplitLinkObservable(executionDefinitions, operation) {
    return new Observable(function splitLinkSubscriptionFn(observer) {
        const operationContext = operation.getContext();
        const executions = executionDefinitions.map((execution)=>createExecutionPromise(execution, operationContext));
        const promises = executions.map((execution)=>execution.promise);
        Promise.all(promises).then(function subLinksResolved(results) {
            const stitchedResult = stitchSubLinksResults(results);
            if (stitchedResult.success) {
                observer.next(stitchedResult.result);
            } else {
                observer.error(stitchedResult.error);
            }
            observer.complete();
        }).catch(function runTimeError(error) {
            observer.error(error);
        });
        return function splitObservableCleanup() {
            executions.forEach((execution)=>{
                execution.unsubscribe();
            });
        };
    });
}

//# sourceMappingURL=createSplitLinkObservable.js.map